import { useState } from "react";

export const usePaginations = (initialSortBy = 'id', initialSortOrder = 'asc') => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortBy, setSortBy] = useState(initialSortBy);
    const [sortOrder, setSortOrder] = useState(initialSortOrder);
    const [searchTerm, setSearchTerm] = useState('');
    const [metaData, setMetaData] = useState({});

    return {
        page,
        pageSize,
        sortBy,
        sortOrder,
        searchTerm,
        setPage,
        setPageSize,
        setSortBy,
        setSortOrder,
        setSearchTerm,
        metaData,
        setMetaData
    }
}